// Iter 239 — lets a page publish its real breadcrumb trail to the single
// global <Breadcrumbs /> rendered by Layout, instead of painting a second
// crumb row of its own (KB article/category pages, which know their
// category chain only after fetching).
import { createContext, useContext, useEffect, useRef, useState } from "react";

const BreadcrumbContext = createContext({ trail: null, publish: () => {} });

export function BreadcrumbProvider({ children }) {
  const [trail, setTrail] = useState(null);
  return (
    <BreadcrumbContext.Provider value={{ trail, publish: setTrail }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function usePublishedTrail() {
  return useContext(BreadcrumbContext).trail;
}

/** Publish `items` ([{label, to?}]) as the page's trail; cleared on unmount. */
export function usePageBreadcrumb(items) {
  const { publish } = useContext(BreadcrumbContext);
  const key = JSON.stringify(items || null);
  const ref = useRef(items);
  ref.current = items;
  useEffect(() => {
    publish(ref.current && ref.current.length ? ref.current : null);
    return () => publish(null);
  }, [key, publish]); // eslint-disable-line react-hooks/exhaustive-deps
}
